import { render, staticRenderFns } from "./TribzzPromo.vue?vue&type=template&id=1345fee6&scoped=true"
import script from "./TribzzPromo.vue?vue&type=script&lang=js"
export * from "./TribzzPromo.vue?vue&type=script&lang=js"
import style0 from "./TribzzPromo.vue?vue&type=style&index=0&id=1345fee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345fee6",
  null
  
)

export default component.exports